import { create } from 'zustand';

interface SearchParamsType {
  searchParam: string;
  selectedModel?: CF.API.Models.Model;
  setSelectedModel: (model: CF.API.Models.Model) => void;
  updateSearchParam: (query: string) => void;
  updateUserOrOrgId: (userOrOrgId?: string) => void;
  userOrOrgId?: string;
}

export const useUniversalSearchStore = create<SearchParamsType>((set) => ({
  searchParam: '',
  selectedModel: undefined,
  setSelectedModel: (selectedModel: CF.API.Models.Model) => {
    set({ selectedModel });
  },
  updateSearchParam: (searchParam) => {
    set({ searchParam });
  },
  updateUserOrOrgId: (userOrOrgId) => {
    set({ userOrOrgId });
  },
  userOrOrgId: undefined,
}));
